import { get, post } from '../base'
import type { ReturnedUniverse } from '../universe'

interface Tag {
  tagId: number
  tagDisplayName: string
}

export interface ReturnedCharacter {
  charId: number
  charName: string
  tags: Tag[]
  charDescription: string
  charAvatarUrl: string
  createTimeUtc: number
}

export interface ReturnedMessage {
  charOrUserId?: number | null
  name: string
  expression?: string | null
  role?: string | null
  action?: string
  message: string
  messageTimestampUtc?: number | null
}

interface CharacterGroup {
  groupId: number
  groupName: string
  groupAvatar: string
  useAvatarImage?: boolean
}

interface GetUniversesPayload {
  favoriteTagIds: number[]
  favoriteCharGroupIds: number[]
  favoriteCharIds: number[]
}

interface GetCharsByTagsPayload {
  tagIds: number[]
}

interface GetCharsByTagsResult {
  chars: ReturnedCharacter[]
}

interface GetCharGroupsResult {
  groups: CharacterGroup[]
}

interface PreloadUniversePayload {
  favoriteTagIds: number[]
  favoriteCharGroupIds: number[]
  favoriteCharIds: number[]
  universe_ids_blacklist: number[]
}

interface PreloadUniverseResult {
  message: string
}

class RecommendationService {
  async getUniverses(payload: GetUniversesPayload) {
    return post<ReturnedUniverse[]>('/recommendation/getUniverse', payload)
  }

  async getCharsByTags(payload: GetCharsByTagsPayload) {
    return post<GetCharsByTagsResult>('/recommendation/chars/byTags', payload)
  }

  async getCharGroups() {
    return get<GetCharGroupsResult>('/group/groupList')
  }

  async preloadUniverse(payload: PreloadUniversePayload) {
    return post<PreloadUniverseResult>('/recommendation/preloadUniverse', payload)
  }
}

export const recommendationService = new RecommendationService()
